import { defaultCt } from "../context";


const createConfig = (config = defaultCt) => {
    return config
}
export { createConfig }